class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');
    window.scrollTo(0, scrollTop);

    // ボックスアニメーションの作成
    const loadingBox = document.querySelectorAll('.js-loading-box');
    const mvText = document.querySelectorAll('.js-mv-text');
    const mvImages1 = document.querySelectorAll('.js-mv-images1');
    const mvImages2 = document.querySelectorAll('.js-mv-images2');
    const mvImages3 = document.querySelectorAll('.js-mv-images3');
    const mvImages4 = document.querySelectorAll('.js-mv-images4');
    const mvImages5 = document.querySelectorAll('.js-mv-images5');
    const mvImages6 = document.querySelectorAll('.js-mv-images6');
    const mvImages7 = document.querySelectorAll('.js-mv-images7');
    const mvImages8 = document.querySelectorAll('.js-mv-images8');
    const tl = gsap.timeline({defaults: {duration: 1} });

    tl.to(loadingBox,{width: '100vw', duration: 0.5}, '+=0.5')
    .to(loadingBox,{height: '100vh', duration: 0.5}, '+=0.8')
    .from(mvText,{opacity: 0}, '+=1')
    .fromTo(mvImages2,{y: '3rem',opacity: 0},{y: 0, opacity: 1}, '+=0.2')
    .fromTo(mvImages3,{y: '3rem',opacity: 0},{y: 0, opacity: 1}, '<')
    .fromTo(mvImages1,{y: '3rem',opacity: 0},{y: 0, opacity: 1}, '+=0.2')
    .fromTo(mvImages4,{y: '3rem',opacity: 0},{y: 0, opacity: 1}, '<')
    .fromTo(mvImages5,{y: '3rem',opacity: 0},{y: 0, opacity: 1}, '<')
    .fromTo(mvImages6,{y: '3rem',opacity: 0},{y: 0, opacity: 1}, '<')
    .fromTo(mvImages7,{y: '3rem',opacity: 0},{y: 0, opacity: 1}, '<')
    .fromTo(mvImages8,{y: '3rem',opacity: 0},{y: 0, opacity: 1}, '<')
    
    setTimeout(() => {
      $(".c-loading").fadeOut(500);
      body.style.top = '';
      body.classList.remove('no_scroll');
    }, 2500);

  }
}